import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "environments/environment";
import { map } from "rxjs/operators";
import { Client } from "app/client/client.model";
import { ClientPotential } from "./client-potential.model";
import { ClientPotentialMapper } from "./client-potential.mapper";
import { CrudAbstractRepository } from "app/crud-abstract/crud-abstract.repository";

@Injectable()
export class ClientPotentialRepository extends CrudAbstractRepository {
  getMapper(): any {
    return ClientPotentialMapper.map;
  }

  getEndpoint(): string {
    return "clientPotential";
  }

  public listByClient(client: Client): Observable<ClientPotential[]> {
    return this.http
      .get<any>(
        `${environment.apiUrl}/client/${client.getId()}/clientPotential`,
        {},
      )
      .pipe(map((response) => response.map(ClientPotentialMapper.map)));
  }

  public add(model: ClientPotential): Observable<ClientPotential> {
    return this.http
      .post<ClientPotential>(
        `${environment.apiUrl}/client/${model
          .getClient()
          .getId()}/clientPotential`,
        model.getRequestParams(),
      )
      .pipe(map((response) => ClientPotentialMapper.map(response)));
  }

  public save(model: ClientPotential): Observable<ClientPotential> {
    return this.http.patch<ClientPotential>(
      `${environment.apiUrl}/clientPotential/${model.getId()}`,
      model.getRequestParams(),
    );
  }

  public delete(model: ClientPotential): Observable<object> {
    return this.http.delete(
      `${environment.apiUrl}/clientPotential/${model.getId()}`,
    );
  }
}
